import React, { useEffect, useContext } from "react";
import { createPortal } from "react-dom";
import CloseIcon from "../../Assets/Images/Close-icon.svg";
import CloseDarkIcon from "../../Assets/Images/Close-dark-icon.png";
import * as StyledDOM from "./ModalPopup.jsx";
import Button from "../Button/Button";
import { Popupscroll } from "../Common-Function/CommonFunctions";
import { DynamicContext } from "../../Context/DynamicContext.js";
const ContentDialog = ({
  isOpen,
  title,
  children,
  onClose,
  onCloseIconClose,
  event,
  showMoreOptions = false,
  moreOptionsLink,
  moreOptionsText = "More Options",
  contentHeight = "",
  contentWidth = "",
  submitButtonLabel = "Submit",
  cancelButtonLabel = "Cancel",
  isCancel = false,
  submitButtonIcon = null,
  showCloseIcon = true,
  showTitle = true,
  dialogHeaderStyle = {},
  overflowY = false,
  showActionButton = true,
  isSubmitDisabled = false,
  submitButtonStyle = {},
  extraButton,
  className = "",
}) => {
  const { isDarkMode } = useContext(DynamicContext);
  useEffect(() => {
    Popupscroll(isOpen);
    return () => Popupscroll(false);
  }, [isOpen]);

  if (!isOpen) return null;
  const dialogContent = (
    <StyledDOM.StyledPopupMainContainer
      className={`popupmain-container ${className || ""}`}
    >
      <StyledDOM.StyledPopupInnerContainer
        contentHeight={contentHeight}
        contentWidth={contentWidth}
        className={`popupinner-container ${className ? `${className}-inner` : ""}`}
        style={{
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {showTitle && (
          <StyledDOM.StyledHeader>
            <StyledDOM.StyledHeading style={dialogHeaderStyle}>
              {title}
            </StyledDOM.StyledHeading>

            {showCloseIcon && (
              <StyledDOM.StyledPopupCancelIconContainer
                onClick={onCloseIconClose}
              >
                <StyledDOM.StyledPopupCancelIcon
                  src={isDarkMode ? CloseDarkIcon : CloseIcon}
                  alt="CloseIcon"
                  className="content-dialog-close-icon"
                />
              </StyledDOM.StyledPopupCancelIconContainer>
            )}
          </StyledDOM.StyledHeader>
        )}
        <div
          style={{
            flex: "1 1 auto",
            overflowY: overflowY ? "auto" : "visible",
            minHeight: 0,
          }}
        >
          {children}
        </div>
        <StyledDOM.StyledDiv showMoreOptions={showMoreOptions}>
          {showMoreOptions && (
            <StyledDOM.StyledAnchor onClick={moreOptionsLink}>
              {moreOptionsText}
            </StyledDOM.StyledAnchor>
          )}
          {showActionButton && (
            <StyledDOM.StyledButtonDiv>
              <Button
                label={cancelButtonLabel}
                isCancel={true}
                event={onClose}
              />
              <Button
                label={submitButtonLabel}
                icon={submitButtonIcon}
                event={event}
                backgroundColor="#6860ee"
                disable={isSubmitDisabled}
                style={submitButtonStyle}
              />
              {extraButton}
            </StyledDOM.StyledButtonDiv>
          )}
        </StyledDOM.StyledDiv>
      </StyledDOM.StyledPopupInnerContainer>
    </StyledDOM.StyledPopupMainContainer>
  );

  if (typeof document === "undefined") {
    return dialogContent;
  }

  return createPortal(dialogContent, document.body);
};

export default ContentDialog;
